// extracted by mini-css-extract-plugin
export default {"root":"style_root__uZipt","arrow":"style_arrow__1NC4P"};